import styles from "./first-game.module.css";
import ranaLookingStars from "illustrations/rana/rana-looking-stars.webp";
import tokenService from "services/token.service";
import { useTranslation } from "react-i18next";

const FirstGame = () => {
  const role = tokenService.getRole();
  const { t } = useTranslation();

  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <img src={ranaLookingStars} className={styles.image} alt="first-game" />
        <div className={styles.text}>
          <p className="title-4">{t("dashboard.first-game.title")}</p>
          <h2 className="title-1-variant-low">
            {role === "admin"
              ? t("dashboard.first-game.admin-text")
              : t("dashboard.first-game.player-text")}
          </h2>
        </div>
      </div>
    </div>
  );
};

export default FirstGame;
